import * as Sentry from "@sentry/vue";
import { createApp } from "vue";
import { vfmPlugin } from "vue-final-modal";
import { createI18n } from "vue-i18n";
import ToastPlugin from "vue-toast-notification";
import "vue-toast-notification/dist/theme-bootstrap.css";
import App from "./App.vue";
import axiosPlugin from "./axiosPlugin.mjs";
import router from "./router";
import store from "./store";
import translates from "./utilities/translates";
/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";

/* import font awesome icon component */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

/* import specific icons */
import {
  faArrowLeft,
  faBars,
  faBatteryFull,
  faBuilding,
  faCalendarDays,
  faCalendarXmark,
  faCircleCheck,
  faCirclePlus,
  faDisplay,
  faEye,
  faEyeSlash,
  faFile,
  faFileArrowUp,
  faFileExport,
  faFilePdf,
  faLaptop,
  faLayerGroup,
  faLightbulb,
  faList,
  faListCheck,
  faLocationDot,
  faMagnifyingGlass,
  faMicrophone,
  faPenNib,
  faPenToSquare,
  faPlug,
  faSliders,
  faSpinner,
  faTag,
  faTrashCan,
  faTruck,
  faTriangleExclamation,
  faVideo,
  faVolumeHigh,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";

import "@/css/toast-custom.css";

/* add icons to the library */
library.add(
  faArrowLeft,
  faBars,
  faBatteryFull,
  faBuilding,
  faCalendarDays,
  faCalendarXmark,
  faCircleCheck,
  faCirclePlus,
  faDisplay,
  faEye,
  faEyeSlash,
  faFile,
  faFileArrowUp,
  faFileExport,
  faFilePdf,
  faLaptop,
  faLayerGroup,
  faLightbulb,
  faList,
  faListCheck,
  faLocationDot,
  faMagnifyingGlass,
  faMicrophone,
  faPenNib,
  faPenToSquare,
  faPlug,
  faSliders,
  faSpinner,
  faTag,
  faTrashCan,
  faTruck,
  faTriangleExclamation,
  faVideo,
  faVolumeHigh,
  faXmark
);

// Create a new instance of VueI18n
const i18n = createI18n({
  locale: "it",
  fallbackLocale: "en",
  messages: translates,
});

const app = createApp(App);

// Initialize Sentry only when a DSN is provided (e.g. in staging/production).
const sentryDsn = process.env.VUE_APP_SENTRY_DSN;
// Conservative default; an explicit env value (including 0) is always respected,
// while an empty string falls back to the default.
const sentryTracesSampleRateEnv = process.env.VUE_APP_SENTRY_TRACES_SAMPLE_RATE;
const sentryTracesSampleRate =
  sentryTracesSampleRateEnv !== undefined && sentryTracesSampleRateEnv !== ""
    ? Number(sentryTracesSampleRateEnv)
    : 0.1;

if (sentryDsn) {
  Sentry.init({
    app,
    dsn: sentryDsn,
    environment: process.env.VUE_APP_NODE_ENV || process.env.NODE_ENV,
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracesSampleRate: sentryTracesSampleRate,
    autoSessionTracking: false,
  });
}

// Register the FontAwesomeIcon component globally
app.component("font-awesome-icon", FontAwesomeIcon);
app.use(axiosPlugin);
app.use(store);
app.use(i18n);
app.use(ToastPlugin, {
  position: "top", // forza il posizionamento
  duration: 3500, // ms
  dismissible: true, // mostra la X
  pauseOnHover: true,
  queue: false,
});

app.use(
  vfmPlugin({
    key: "$vfm",
    componentName: "VueFinalModal",
    dynamicContainerName: "ModalsContainer",
  })
);
app.use(router).mount("#app");
// Rendi axios disponibile globalmente
// app.config.globalProperties.$axios = axios;
